import React, { useEffect, useState } from "react";
import "../../../assets/css/accountmetrics.scss";
import Loader from "../../../reusableComponents/Loader";
import { ReactComponent as Program } from "../../../assets/icons/program.svg";
import { ReactComponent as AccountInsights } from "../../../assets/icons/accountInsights.svg";
import { ReactComponent as TradingHistory } from "../../../assets/icons/tradingHistory.svg";
import { ReactComponent as AccountAnalysis } from "../../../assets/icons/accountAnalysis.svg";
import PublicShareDashboard from "./PublicShareDashboard";
import { useNavigate, useParams } from "react-router";
import {
  fetchAccountDetails,
  fetchAccountInsights,
  fetchAccountMetrics,
  fetchAccountObjectives,
  fetchPerformanceChart,
} from "../../../utilities/PublicShare";
import AdvancedInsightsShare from "./AccountInsightsShare";
import TradingHistoryShare from "./TradingHistoryShare";
import AccountAnalysisShare from "./AccountAnalysis";
import MobileTabs from "../../../reusableComponents/MobileTabs/MobileTabs";
import html2canvas from "html2canvas";
const AccountMetricPublicShare = () => {
  const [mainTabination, setMainTabination] = useState(1);
  const navigate = useNavigate();
  const tabItems = [
    { name: "Program Objectives", value: 1, icon: <Program /> },
    { name: "Advanced Insights", value: 2, icon: <AccountInsights /> },
    { name: "Trading History", value: 3, icon: <TradingHistory /> },
    { name: "Account Analysis", value: 4, icon: <AccountAnalysis /> },
  ];

  const handleTabClick = (value) => {
    setMainTabination(value);
  };

  const { platform, accountId } = useParams();

  const [data, setData] = useState({
    performanceChart: null,
    accountMetrics: null,
    accountDetails: null,
    accountObjectives: null,
    accountInsights: null,
    success: null,
  });
  const [loading, setIsloading] = useState(false);
  const [error, setError] = useState(null);
  console.log("performance", data);
  console.log({ ...data }, "mahi");
  useEffect(() => {
    const fetchData = async () => {
      setIsloading(true);
      try {
        const [performance, metrics, details, objectives, insights] =
          await Promise.all([
            fetchPerformanceChart(accountId, platform),
            fetchAccountMetrics(accountId, platform),
            fetchAccountDetails(accountId, platform),
            fetchAccountObjectives(accountId, platform),
            fetchAccountInsights(accountId, platform),
          ]);

        setData({
          performanceChart: performance.success ? performance.data : null,
          accountMetrics: metrics.success ? metrics.data : null,
          accountDetails: details.success ? details.data : null,
          accountObjectives: objectives.success ? objectives.data : null,
          accountInsights: insights.success ? insights.data : null,
          success: performance.success,
        });
        setIsloading(false);

        // Check if any request failed
        if (
          !performance.success ||
          !metrics.success ||
          !details.success ||
          !objectives.success ||
          !insights.success
        ) {
          setError(
            "Some data could not be loaded. Check the console for details."
          );
          setIsloading(false);
        }
      } catch (err) {
        console.error("Error during fetch:", err); // Log any other errors
        setError("An error occurred while fetching data.");
        setIsloading(false);
      }
    };

    platform && accountId && fetchData();
  }, [accountId, platform]);

  const handleCapture = async () => {
    try {
      const elementsToExclude = [
        ...document.querySelectorAll(
          ".exclude, .intercom-lightweight-app, .weglot-container.wg-default"
        ),
      ];

      const elementsWithParents = elementsToExclude.map((element) => ({
        element,
        parent: element.parentNode,
        nextSibling: element.nextSibling,
      }));

      elementsToExclude.forEach((element) => {
        if (element) element.parentNode.removeChild(element);
      });

      const canvas = await html2canvas(document.body, { scale: 2 });

      elementsWithParents.forEach(({ element, parent, nextSibling }) => {
        if (nextSibling) {
          parent.insertBefore(element, nextSibling);
        } else {
          parent.appendChild(element);
        }
      });

      const image = canvas.toDataURL("image/png");

      const link = document.createElement("a");
      link.href = image;
      link.download = "screenshot.png";
      link.click();
    } catch (error) {
      console.error("Error capturing the screenshot:", error);
    }
  };

  return (
    <div
      className="AccountMetricsContainer publicSharePage PageContainer"
      style={{ position: "relative", padding: "30px" }}
    >
      {mainTabination !== 4 && <Loader open={false} />}

      <div className="topHeaderBox">
        <h1>
          Alpha<span> Capital</span>
        </h1>
        <div className="rightCornerSect exclude">
          <button onClick={() => navigate("/signup")}>Sign Up</button>
          <button onClick={handleCapture}>Share</button>
        </div>
      </div>

      <div className="accntMetricsHeader">
        <div className="newTabination">
          {tabItems.map((tab) => (
            <div
              key={tab.value}
              onClick={() => handleTabClick(tab.value)}
              className={`newTabination-item ${
                mainTabination === tab.value ? "active" : ""
              }`}
            >
              <div className="svg-con">{tab?.icon}</div>
              {tab.name}
            </div>
          ))}
        </div>
      </div>
      <div className="mobileTabOption">
        <MobileTabs
          activeTab={mainTabination}
          setActiveTab={setMainTabination}
          tabItems={tabItems}
        />
      </div>

      <div className="tabContent">
        {mainTabination === 1 && (
          <PublicShareDashboard data={data} loading={loading} />
        )}
        {mainTabination === 2 && (
          <AdvancedInsightsShare
            AdvStats={data?.accountInsights && data?.accountInsights}
            data={data?.accountMetrics.calculated_data}
            TradeJournalNew={data?.accountMetrics}
            TradingHistory={data?.accountMetrics?.data}
          />
        )}
        {mainTabination === 3 && (
          <TradingHistoryShare TradingHistory={data?.accountMetrics.data} />
        )}
        {mainTabination === 4 && <AccountAnalysisShare />}
      </div>
    </div>
  );
};

export default AccountMetricPublicShare;
